var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.50228,
    y: 4.86263,
    width: 31.6667,
    height: 31.6667,
    rx: 15.8333,
    stroke: "white",
    strokeWidth: 1.66667
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_8426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6148 24.0491C25.5494 24.1152 25.4716 24.1677 25.3857 24.2035C25.2999 24.2394 25.2078 24.2578 25.1148 24.2578C25.0218 24.2578 24.9297 24.2394 24.8439 24.2035C24.7581 24.1677 24.6802 24.1152 24.6148 24.0491C24.482 23.9149 24.4075 23.7338 24.4075 23.545C24.4075 23.3562 24.482 23.175 24.6148 23.0408L26.2382 21.4075H12.7265C12.5373 21.4075 12.3559 21.3323 12.2221 21.1985C12.0883 21.0648 12.0132 20.8833 12.0132 20.6941C12.0132 20.5049 12.0883 20.3235 12.2221 20.1897C12.3559 20.0559 12.5373 19.9808 12.7265 19.9808H26.2382L24.6148 18.3475C24.4845 18.2136 24.4116 18.0342 24.4116 17.8475C24.4116 17.6607 24.4845 17.4813 24.6148 17.3475C24.6802 17.2813 24.7581 17.2289 24.8439 17.193C24.9297 17.1572 25.0218 17.1388 25.1148 17.1388C25.2078 17.1388 25.2999 17.1572 25.3857 17.193C25.4716 17.2289 25.5494 17.2813 25.6148 17.3475L28.4465 20.1941C28.5772 20.3277 28.6504 20.5072 28.6504 20.6941C28.6504 20.881 28.5772 21.0605 28.4465 21.1941L25.6148 24.0491Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_8426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(12.0029 12.3613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNext);
export default __webpack_public_path__ + "static/media/button-next.18fd0b412e8eb32d778f56b399cc6957.svg";
export { ForwardRef as ReactComponent };